// import { useCreateContext } from '../create-context';
// import { reducer, initialState } from './app.reducer';

// const [state, useDispatch, provider] = useCreateContext(initialState, reducer);
// export const useStickyState = state;
// export const useStickyDispatch = useDispatch;
// export const StickyProvider = provider;


import React, { createContext, useReducer, useContext } from 'react';
import { reducer, initialState } from './app.reducer';

// Context and Provider creation
const AppContext = createContext();
const AppDispatchContext = createContext();

// Custom hook to use state
export const useStickyState = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("useStickyState must be used within a StickyProvider");
  }
  return context;
};

// Custom hook to use dispatch
export const useStickyDispatch = () => {
  const context = useContext(AppDispatchContext);
  if (context === undefined) {
    throw new Error("useStickyDispatch must be used within a StickyProvider");
  }
  return context;
};

// Provider component
export const StickyProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>
        {children}
      </AppDispatchContext.Provider>
    </AppContext.Provider>
  );
};
